import { Commodity } from '@enmon/commons/lib/shared';

export const ENERGY_COMMODITIES = [Commodity.Electricity, Commodity.NaturalGas, Commodity.Thermal] as const;

export const CONSUMPTION_COMMODITIES = [...ENERGY_COMMODITIES, Commodity.Water] as const;
